import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_TASKTAG] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.tasktag = payload
  },
  [types.SET_TASKTAGS] (state, payload) {
    state.tasktags = payload.data
    state.pagination = { total: payload.total, current_page: payload.current_page }
  },
  [types.SET_CONTACTS] (state, payload) {
    state.contacts = payload.data
    state.paginationC = payload.meta.pagination
  }
}
